export default __webpack_public_path__ + "static/media/SmallCTExcessiveMovementEdited.1961280c.png";